export interface GetCustomerAdverts {
  customerId: string;
  keywords?: string;
  soldStatus?: number;
  soldStatuses?: number[];
  advertStatus?: number;
  advertStatuses?: number[];
  withJoins?: {}[];
}
